var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inquiry-table" },
    [
      _c("div", { staticClass: "m-content" }, [
        _c("div", { staticClass: "m-portlet m-portlet--mobile" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("form", { staticClass: "m-form" }, [
              _c("div", { staticClass: "row mb-4" }, [
                _c("div", { staticClass: "col-12 col-md-5" }, [
                  _c("div", { staticClass: "m-form__group form-group" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-checkbox-inline" }, [
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.status1,
                              expression: "status1"
                            }
                          ],
                          attrs: { type: "checkbox", name: "status1" },
                          domProps: {
                            checked: Array.isArray(_vm.status1)
                              ? _vm._i(_vm.status1, null) > -1
                              : _vm.status1
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.status1,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.status1 = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.status1 = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.status1 = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " Neu\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.wait,
                              expression: "wait"
                            }
                          ],
                          attrs: { type: "checkbox", name: "wait" },
                          domProps: {
                            checked: Array.isArray(_vm.wait)
                              ? _vm._i(_vm.wait, null) > -1
                              : _vm.wait
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.wait,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.wait = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.wait = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.wait = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " Wait\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.status2,
                              expression: "status2"
                            }
                          ],
                          attrs: { type: "checkbox", name: "status2" },
                          domProps: {
                            checked: Array.isArray(_vm.status2)
                              ? _vm._i(_vm.status2, null) > -1
                              : _vm.status2
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.status2,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.status2 = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.status2 = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.status2 = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " Anfrage gesendet\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.status3,
                              expression: "status3"
                            }
                          ],
                          attrs: { type: "checkbox", name: "status3" },
                          domProps: {
                            checked: Array.isArray(_vm.status3)
                              ? _vm._i(_vm.status3, null) > -1
                              : _vm.status3
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.status3,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.status3 = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.status3 = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.status3 = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " Kunde angelegt\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.reminder,
                              expression: "reminder"
                            }
                          ],
                          attrs: { type: "checkbox", name: "reminder" },
                          domProps: {
                            checked: Array.isArray(_vm.reminder)
                              ? _vm._i(_vm.reminder, null) > -1
                              : _vm.reminder
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.reminder,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.reminder = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.reminder = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.reminder = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " Reminder\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.noreminder,
                              expression: "noreminder"
                            }
                          ],
                          attrs: { type: "checkbox", name: "noreminder" },
                          domProps: {
                            checked: Array.isArray(_vm.noreminder)
                              ? _vm._i(_vm.noreminder, null) > -1
                              : _vm.noreminder
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.noreminder,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.noreminder = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.noreminder = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.noreminder = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " Nur keine Notizen\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.packageOnWay,
                              expression: "packageOnWay"
                            }
                          ],
                          attrs: { type: "checkbox", name: "packageOnWay" },
                          domProps: {
                            checked: Array.isArray(_vm.packageOnWay)
                              ? _vm._i(_vm.packageOnWay, null) > -1
                              : _vm.packageOnWay
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.packageOnWay,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.packageOnWay = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.packageOnWay = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.packageOnWay = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " Nur Pakete Unterwegs\n                                        "
                        ),
                        _c("span")
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-5" }, [
                  _c("div", { staticClass: "m-form__group form-group" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-checkbox-inline" }, [
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showAClient,
                              expression: "showAClient"
                            }
                          ],
                          attrs: { type: "checkbox", name: "showAClient" },
                          domProps: {
                            checked: Array.isArray(_vm.showAClient)
                              ? _vm._i(_vm.showAClient, null) > -1
                              : _vm.showAClient
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.showAClient,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.showAClient = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.showAClient = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.showAClient = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " A Kunde\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showBClient,
                              expression: "showBClient"
                            }
                          ],
                          attrs: { type: "checkbox", name: "showBClient" },
                          domProps: {
                            checked: Array.isArray(_vm.showBClient)
                              ? _vm._i(_vm.showBClient, null) > -1
                              : _vm.showBClient
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.showBClient,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.showBClient = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.showBClient = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.showBClient = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " B Kunde\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showCClient,
                              expression: "showCClient"
                            }
                          ],
                          attrs: { type: "checkbox", name: "showCClient" },
                          domProps: {
                            checked: Array.isArray(_vm.showCClient)
                              ? _vm._i(_vm.showCClient, null) > -1
                              : _vm.showCClient
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.showCClient,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.showCClient = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.showCClient = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.showCClient = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " C Kunde\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showDClient,
                              expression: "showDClient"
                            }
                          ],
                          attrs: { type: "checkbox", name: "showDClient" },
                          domProps: {
                            checked: Array.isArray(_vm.showDClient)
                              ? _vm._i(_vm.showDClient, null) > -1
                              : _vm.showDClient
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.showDClient,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.showDClient = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.showDClient = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.showDClient = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " D Kunde\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showEClient,
                              expression: "showEClient"
                            }
                          ],
                          attrs: { type: "checkbox", name: "showEClient" },
                          domProps: {
                            checked: Array.isArray(_vm.showEClient)
                              ? _vm._i(_vm.showEClient, null) > -1
                              : _vm.showEClient
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.showEClient,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.showEClient = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.showEClient = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.showEClient = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " E Kunde\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showFClient,
                              expression: "showFClient"
                            }
                          ],
                          attrs: { type: "checkbox", name: "showFClient" },
                          domProps: {
                            checked: Array.isArray(_vm.showFClient)
                              ? _vm._i(_vm.showFClient, null) > -1
                              : _vm.showFClient
                          },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              var $$a = _vm.showFClient,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.showFClient = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.showFClient = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.showFClient = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          " F Kunde\n                                        "
                        ),
                        _c("span")
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(3)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-5" }, [
                _c("div", { staticClass: "col-12 col-md-5" }, [
                  _c("div", { staticClass: "m-form__group form-group" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-checkbox-inline" }, [
                      _c("label", { staticClass: "m-radio" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inquiryType,
                              expression: "inquiryType"
                            }
                          ],
                          attrs: {
                            name: "inquiryType",
                            type: "radio",
                            value: "0"
                          },
                          domProps: { checked: _vm._q(_vm.inquiryType, "0") },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              _vm.inquiryType = "0"
                            }
                          }
                        }),
                        _vm._v(
                          " Alle\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-radio" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inquiryType,
                              expression: "inquiryType"
                            }
                          ],
                          attrs: {
                            name: "inquiryType",
                            type: "radio",
                            value: "1"
                          },
                          domProps: { checked: _vm._q(_vm.inquiryType, "1") },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              _vm.inquiryType = "1"
                            }
                          }
                        }),
                        _vm._v(
                          " Produktfotografie Formular\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-radio" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inquiryType,
                              expression: "inquiryType"
                            }
                          ],
                          attrs: {
                            name: "inquiryType",
                            type: "radio",
                            value: "2"
                          },
                          domProps: { checked: _vm._q(_vm.inquiryType, "2") },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              _vm.inquiryType = "2"
                            }
                          }
                        }),
                        _vm._v(
                          " Clipping-Agency Formular\n                                        "
                        ),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-radio" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inquiryType,
                              expression: "inquiryType"
                            }
                          ],
                          attrs: {
                            name: "inquiryType",
                            type: "radio",
                            value: "3"
                          },
                          domProps: { checked: _vm._q(_vm.inquiryType, "3") },
                          on: {
                            click: function($event) {
                              return _vm.loadData()
                            },
                            change: function($event) {
                              _vm.inquiryType = "3"
                            }
                          }
                        }),
                        _vm._v(
                          " Neukundenakquise\n                                        "
                        ),
                        _c("span")
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-5" }, [
                  _c("div", { staticClass: "m-form__group form-group" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchString,
                            expression: "searchString"
                          }
                        ],
                        staticClass: "form-control m-input",
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          name: "searchString"
                        },
                        domProps: { value: _vm.searchString },
                        on: {
                          keydown: function($event) {
                            return _vm.loadData()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchString = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "m-section__content" }, [
              _c(
                "table",
                {
                  staticClass:
                    "table table-striped- table-bordered table-hover table-checkable",
                  attrs: { id: "inquiry-table" }
                },
                [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.inquiryArr, function(inquiry, key) {
                      return _c("tr", [
                        _c("td", [
                          inquiry.client_id != 0
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: "/kunde-" + inquiry.client_id,
                                    target: "_blank",
                                    title: ""
                                  }
                                },
                                [_vm._v(_vm._s(inquiry.id))]
                              )
                            : _c("span", [_vm._v(_vm._s(inquiry.id))]),
                          _c("br"),
                          _c(
                            "button",
                            { staticClass: "btn btn-metal btn-metal-mini" },
                            [_vm._v(_vm._s(inquiry.fromWebsite))]
                          ),
                          _c("br"),
                          _vm._v(" "),
                          inquiry.reminder
                            ? _c(
                                "button",
                                { staticClass: "btn btn-warning btn-sm mt-2" },
                                [_vm._v("REMINDER")]
                              )
                            : _vm._e(),
                          _c("br"),
                          _vm._v(" "),
                          inquiry.affiliate_id > 0
                            ? _c(
                                "button",
                                { staticClass: "btn btn-danger btn-sm mt-2" },
                                [
                                  _vm._v(
                                    "Affiliate von: " +
                                      _vm._s(inquiry.affiliate_id)
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(inquiry.eingang))]),
                        _vm._v(" "),
                        _c("td", [
                          inquiry.status_id == 1 && inquiry.wait == 1
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--info m-badge--wide"
                                },
                                [_vm._v("wait")]
                              )
                            : inquiry.status_id == 1
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--danger m-badge--wide"
                                },
                                [_vm._v(_vm._s(inquiry.status))]
                              )
                            : inquiry.status_id == 2
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--metal m-badge--wide"
                                },
                                [_vm._v(_vm._s(inquiry.status))]
                              )
                            : inquiry.status_id == 3
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--info m-badge--wide"
                                },
                                [_vm._v(_vm._s(inquiry.status))]
                              )
                            : inquiry.status_id == 4
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--danger m-badge--wide"
                                },
                                [_vm._v(_vm._s(inquiry.status))]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { width: "250" } }, [
                          _c(
                            "div",
                            { staticClass: "m-card-user m-card-user--sm" },
                            [
                              _c("div", { staticClass: "m-card-user__pic" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "m-card-user__no-photo m--bg-fill-success",
                                    class:
                                      "m-badge--client-class-" + inquiry.classId
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(inquiry.className))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "m-card-user__details" },
                                [
                                  inquiry.firma != ""
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "m-card-user__name m--font-primary",
                                          staticStyle: { "max-width": "350px" }
                                        },
                                        [_vm._v(_vm._s(inquiry.firma))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "m-card-user__name",
                                      staticStyle: { "max-width": "350px" }
                                    },
                                    [_vm._v(_vm._s(inquiry.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "m-card-user__name",
                                      staticStyle: { "max-width": "350px" }
                                    },
                                    [
                                      _c("small", [
                                        _c("i", { staticClass: "fa fa-at" }),
                                        _vm._v(" " + _vm._s(inquiry.email))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  inquiry.telefon != ""
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "m-card-user__name",
                                          staticStyle: {
                                            "white-space": "nowrap"
                                          }
                                        },
                                        [
                                          _c("small", [
                                            _c("i", {
                                              staticClass: "fa fa-phone"
                                            }),
                                            _vm._v(
                                              " " + _vm._s(inquiry.telefon)
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { width: "200" } }, [
                          _c("table", { staticClass: "table-sm w-100" }, [
                            _c("tbody", [
                              _c("tr", [
                                _c("td", { attrs: { width: "70" } }, [
                                  _vm._v("Kategorie:")
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(inquiry.categoryName))])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [_vm._v("Produkttyp:")]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(inquiry.produkttyp))])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [_vm._v("Produkte:")]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(inquiry.produkt))])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [_vm._v("Preis:")]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(inquiry.price) + " €")])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [_vm._v("KW:")]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(inquiry.kw))])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { nowrap: "" } }, [
                          inquiry.approxmate_amout < 2
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--danger m-badge--wide"
                                },
                                [_vm._v(_vm._s(inquiry.anzahlCa))]
                              )
                            : inquiry.approxmate_amout > 5
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--success m-badge--wide"
                                },
                                [_vm._v(_vm._s(inquiry.anzahlCa))]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--info m-badge--wide"
                                },
                                [_vm._v(_vm._s(inquiry.anzahlCa) + " Bilder")]
                              ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-2" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "m-badge  m-badge--brand m-badge--wide"
                              },
                              [_vm._v(_vm._s(inquiry.sum))]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", {
                          staticStyle: { "max-width": "550px" },
                          domProps: { innerHTML: _vm._s(inquiry.anfrage) }
                        }),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", { staticClass: "mb-2" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { href: "/anfrage-" + inquiry.id }
                              },
                              [_vm._v("Zur Anfrage")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-2" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-hubspot",
                                attrs: {
                                  target: "_blank",
                                  href:
                                    "https://app-eu1.hubspot.com/contacts/25794910/deal/" +
                                    inquiry.hubspot_id
                                }
                              },
                              [_vm._v("Zu Hubspot")]
                            )
                          ]),
                          _vm._v(" "),
                          inquiry.status_id == 1
                            ? _c("div", { staticClass: "mb-2" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "m-badge  m-badge--success m-badge--wide",
                                    staticStyle: { "white-space": "nowrap" },
                                    attrs: {
                                      "crm-framework": "inquiry-send",
                                      "inquiry-id": inquiry.id,
                                      href: "#"
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "la la-edit" }),
                                    _vm._v(" Anfrage gesendet")
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          inquiry.status_id == 1 && inquiry.wait == 0
                            ? _c("div", { staticClass: "mb-2" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "m-badge  m-badge--metal m-badge--wide inquiry-set-wait",
                                    attrs: { "inquiry-id": inquiry.id }
                                  },
                                  [_vm._v("Wait")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          inquiry.status_id == 2
                            ? _c("div", { staticClass: "mb-2" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "m-badge  m-badge--primary m-badge--wide",
                                    attrs: {
                                      "crm-framework": "open-new-client",
                                      "inquiry-id": inquiry.id
                                    }
                                  },
                                  [_vm._v("Kunde anlegen")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-2" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "m-badge  m-badge--danger m-badge--wide reminder_close",
                                attrs: { "data-reminderid": inquiry.id }
                              },
                              [_vm._v("Absage")]
                            )
                          ]),
                          _vm._v(" "),
                          inquiry.status_id == 2
                            ? _c("div", { staticClass: "mb-2" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "m-badge  m-badge--warning m-badge--wide change_kw",
                                    attrs: {
                                      "inquiry-id": inquiry.id,
                                      "crm-framework": "change-kw"
                                    }
                                  },
                                  [_vm._v("KW ändern")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-2" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "m-badge  m-badge--info m-badge--wide",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    return _vm.showDetails(inquiry)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "Updates (" +
                                    _vm._s(inquiry.updates.length) +
                                    ")"
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.newClients
                            ? _c("div", { staticClass: "mb-2" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "m-badge  m-badge--warning m-badge--wide reminder_update",
                                    attrs: {
                                      href:
                                        "/inquiry-client-is-new-" + inquiry.id
                                    }
                                  },
                                  [_vm._v("Ist Neukunde")]
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    }),
                    0
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("offer-details", {
        attrs: {
          "detail-offer": _vm.detailOffer,
          user: _vm.user,
          "reminder-type-arr": _vm.reminderTypeArr,
          managers: _vm.managers
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v(
              "\n                            Anfragen\n                        "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("b", [_vm._v("Status")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("b", [_vm._v("Kundengruppen")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-2" }, [
      _c(
        "a",
        {
          staticClass:
            "btn btn-primary m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill",
          attrs: { href: "#", "data-modal": "add-anfrage-modal" }
        },
        [
          _c("span", [
            _c("i", { staticClass: "la la-cart-plus" }),
            _vm._v(" "),
            _c("span", [_vm._v("Anfrage anlegen")])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("b", [_vm._v("Anfragentyp")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("b", [_vm._v("Suche")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { attrs: { role: "row" } }, [
        _c("th", { staticClass: "sorting_asc" }, [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", { staticClass: "sorting" }, [_vm._v("Datum")]),
        _vm._v(" "),
        _c("th", { staticClass: "sorting" }, [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", { staticClass: "sorting" }, [_vm._v("Kunde")]),
        _vm._v(" "),
        _c("th", { staticClass: "sorting" }, [_vm._v("Produkt")]),
        _vm._v(" "),
        _c("th", { staticClass: "sorting" }, [_vm._v("Anzahl")]),
        _vm._v(" "),
        _c("th", { staticClass: "sorting" }, [_vm._v("Anfrage")]),
        _vm._v(" "),
        _c("th", { staticClass: "sorting" }, [_vm._v("Aktionen")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }